"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var prism_icons_1 = require("@octanner/prism-icons");
var react_1 = __importDefault(require("react"));
var colors_1 = require("../ThemeProvider/colors");
var defaultTheme_1 = __importDefault(require("../ThemeProvider/defaultTheme"));
var StyledTag = (0, material_1.styled)('button', {
    shouldForwardProp: function (prop) { return !/open|variant|hasMenu/.test(String(prop)); },
})(function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, _d = _a.hasMenu, hasMenu = _d === void 0 ? false : _d;
    return ({
        alignItems: 'center',
        backgroundColor: colors_1.tannerSemantic[variant].background,
        border: 'none',
        borderRadius: 3,
        cursor: hasMenu ? 'pointer' : '',
        color: colors_1.tannerSemantic[variant].color,
        display: 'inline-flex',
        fontSize: 14,
        lineHeight: '140%',
        padding: '2px 8px',
        minHeight: '24px',
        fontWeight: '500',
        fontFamily: defaultTheme_1.default &&
            defaultTheme_1.default['typography'] &&
            defaultTheme_1.default['typography']['fontFamily'],
        '& > svg': {
            marginLeft: 4,
            marginRight: -2,
            transition: 'transform 200ms',
            transform: open ? 'rotate3d(0, 0, 1, -180deg)' : '',
        },
    });
});
var Tag = function (_a) {
    var children = _a.children, _b = _a.hasMenu, hasMenu = _b === void 0 ? false : _b, props = __rest(_a, ["children", "hasMenu"]);
    return (react_1.default.createElement(StyledTag, __assign({}, props, { type: "button", disabled: !hasMenu, hasMenu: hasMenu }),
        children,
        hasMenu && react_1.default.createElement(prism_icons_1.ArrowDown, { fill: "currentColor" })));
};
exports.default = Tag;
//# sourceMappingURL=index.js.map